import { useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that prevents automatic scroll to top
 * when navigating to/from bill detail pages to preserve scroll position
 */
const ScrollToTop = () => {
  const location = useLocation();

  // Disable browser's automatic scroll restoration and handle it manually
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    // Check if we're navigating to or from a bill detail page
    const isBillDetailRoute = /^\/bills\/[^/]+$/.test(location.pathname);
    const isBillsListRoute = location.pathname === '/bills' || location.pathname.startsWith('/bills?');
    
    // Check if we have saved scroll position (indicates we're returning from bill detail)
    const hasSavedScrollPosition = 
      sessionStorage.getItem('billsPageScrollPosition') !== null ||
      localStorage.getItem('billsPageScrollPosition') !== null;
    
    // If navigating to bill detail, don't scroll to top
    // Preserve the current scroll position (already saved in handleBillClick)
    if (isBillDetailRoute) {
      // Prevent React Router's default scroll behavior by doing nothing
      // The scroll position is already saved in handleBillClick
      return;
    }

    // If returning to bills list, NEVER scroll to top - always let Bills.jsx handle it
    // This is CRITICAL - we must never scroll to top when returning from bill detail
    if (isBillsListRoute) {
      // Always skip scrolling to top for bills list - Bills.jsx will restore scroll position
      // This prevents React Router from scrolling to top before our restoration logic runs
      // If we have saved scroll position, definitely don't scroll to top
      if (hasSavedScrollPosition) {
        console.log('🚫 [ScrollToTop] Preventing scroll to top - returning from bill detail');
        return;
      }
      // Even if no saved position, let Bills.jsx handle scroll restoration
      return;
    }

    // For all other routes, scroll to top (normal behavior)
    // But only if we're not in the middle of a bill navigation
    if (!hasSavedScrollPosition) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;

